<template>
  <div class="about">
    <MainBannerBlock
      v-if="_.get(this.$store.state.current_content, 'secondary.MainBannerBlock.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.MainBannerBlock.data')"
    />
    <div class="aboutTabTextContainer container">
      <div class="aboutTabTextTabs">
        <div
          class="aboutTab noto-semibold"
          v-for="(tab, index) in _.get(this.$store.state.current_content,'primary.0.content.tabs')"
          @click="aboutTabClicker(index)"
          :class="activeTab == index ? 'active' : ''"
          :key="index"
        >{{tab.title}}</div>
      </div>
      <div
        class="aboutTabTextInner"
        :class="animateTxt ? 'active' : ''"
        :style="{
                        'height': `${aboutTabHeight}px`
                      }"
      >
        <div class="aboutTabTextHeight" ref="aboutTabTextHeight">
          <div
            class="aboutTabText"
            v-for="(tabTxt, index) in _.get(this.$store.state.current_content,'primary.0.content.tabs')"
            v-if="activeTab == index"
            :key="index"
            v-html="tabTxt.content"
          ></div>
        </div>
      </div>
    </div>
    <div class="counterContainer container">
      <h2 class="other-title" v-if="_.get($store.state.current_content,'primary.0.dinamictable.title')"> {{_.get($store.state.current_content,'primary.0.dinamictable.title')}}</h2>
      <div class="counterInner">
        <div
          class="counterItem"
          v-for="(counter,index) in _.get($store.state.current_content,'primary.0.dinamictable.columnTitles')"
          :key="index"
        >
          <div
            class="num"
          >{{_.get($store.state.current_content,'primary.0.dinamictable.data.0')[index]}}</div>
          <div class="dot"></div>
          <div
            class="ttl noto-semibold"
          >{{_.get($store.state.current_content,'primary.0.dinamictable.data.1')[index]}}</div>
        </div>
      </div>
    </div>
    <LinkBoxesRow
      v-if="_.get(this.$store.state.current_content, 'secondary.LinkBoxesRow.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.LinkBoxesRow.data')"
    />

    <MemberTabs
      v-if="_.get(this.$store.state.current_content, 'secondary.MemberTabs.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.MemberTabs.data')"
      :tabsData="_.get(this.$store.state.indx,'terms.management_category')"
    />
    <AboutLinkBanner
      v-if="_.get(this.$store.state.current_content, 'secondary.AboutLinkBanner.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.AboutLinkBanner.data[0]')"
    />
    <ServiceSlider
      v-if="_.get(this.$store.state.current_content, 'secondary.ServiceSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ServiceSlider')"
      :colorData="newsCol"
    />
    <LinkBanner
      v-if="_.get(this.$store.state.current_content, 'secondary.LinkBanner.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.LinkBanner.data[0]')"
    />
    <NewsBlock
      v-if="_.get(this.$store.state.current_content, 'secondary.NewsBlock.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.NewsBlock')"
      :colorData="newsCol"
    />
  </div>
</template>

<script>
import LinkBoxesRow from "@/components/LinkBoxesRow";
import MainBannerBlock from "@/components/MainBannerBlock";
import MemberTabs from "@/components/MemberTabs";
import AboutLinkBanner from "@/components/AboutLinkBanner";
import ServiceSlider from "@/components/ServiceSlider";
import LinkBanner from "@/components/LinkBanner";
import NewsBlock from "@/components/NewsBlock";

export default {
  name: "About",
  data() {
    return {
      animateTxt: true,
      activeTab: 0,
      aboutTabHeight: 0,
      newsCol: "whiteCol",
    };
  },
  components: {
    MainBannerBlock,
    LinkBoxesRow,
    MemberTabs,
    AboutLinkBanner,
    ServiceSlider,
    LinkBanner,
    NewsBlock,
  },

  methods: {
    aboutTabClicker(id) {
      this.animateTxt = false;
      setTimeout(() => {
        this.activeTab = id;
        this.animateTxt = true;
      }, 450);
      setTimeout(() => {
        this.animateTxt = true;
        this.tabHeight();
      }, 460);
    },
    tabHeight() {
      if(this.$refs.aboutTabTextHeight){
        this.aboutTabHeight = this.$refs.aboutTabTextHeight.clientHeight
      }

    },
    onResize(event) {
      this.tabHeight();
    },
  },

  computed: {
    getAboutTabs() {
      return this.$store.getters.getAboutTabs;
    },
    getCounter() {
      return this.$store.getters.getCounter;
    },
  },

  mounted() {
    window.addEventListener("resize", this.onResize);
    this.tabHeight();
    this.aboutTabClicker(0);
  },
};
</script>

